import React, { useEffect, useRef } from "react";
import * as vega from "vega";
import * as vegaLite from "vega-lite";
import * as vl from "vega-lite-api";
import { Handler } from "vega-tooltip";

// Local data
const data = [
    { a: "A", b: 28 },
    { a: "B", b: 55 },
    { a: "C", b: 43 },
    { a: "D", b: 91 },
    { a: "E", b: 81 },
    { a: "F", b: 53 },
    { a: "G", b: 19 },
    { a: "H", b: 87 },
];

const GraphVegaLiteAPI = ({ graphParams }) => {
    const containerRef = useRef(null);

    useEffect(() => {
        if (!data) {
            console.error("Invalid data provided to Vega-Lite graph");
            return;
        }

        const specTop = vl.markBar({ tooltip: true }) // Set bar chart and enable tooltips
            .data(data) // Bind data
            .encode(
                vl.x().fieldO("a").title("top"), // Ordinal field for x-axis
                vl.y().fieldQ("b").title("-"), // Quantitative field for y-axis
            )
            .width(graphParams?.width || 400)
            .height(graphParams?.height || 200)

        const specBottom = vl.markBar({ tooltip: true }) // Set bar chart and enable tooltips
            .data(data) // Bind data
            .encode(
                vl.x().fieldO("a").title("bottom"), // Ordinal field for x-axis
                vl.y().fieldQ("b").title("-"), // Quantitative field for y-axis
            )
            .width(graphParams?.width || 400)
            .height(graphParams?.height || 200)

        // Create the Vega-Lite spec programmatically using vega-lite-api
        const spec = vl.markBar({ tooltip: true }) // Set bar chart and enable tooltips
            .data(data) // Bind data
            .encode(
                vl.x().fieldO("a").title("Category"), // Ordinal field for x-axis
                vl.y().fieldQ("b").title("Value"), // Quantitative field for y-axis
            )
            .width(graphParams?.width || 400)
            .height(graphParams?.height || 200)
            .toSpec(); // Convert the Vega-Lite API spec to a JSON spec

// -----------------------------------------------------------------------------------------------
        
        // this
        const vegaLiteSpecConcat = vl.vconcat(specTop, specBottom).toSpec();
        const vegaSpecConcat = vegaLite.compile(vegaLiteSpecConcat).spec;
        console.log('specTop: ', specTop)
        console.log('vegaLiteSpecConcat: ', vegaLiteSpecConcat)
        // Parse and render the compiled spec
        const vegaSpec = vegaLite.compile(spec).spec;
        const runtime = vega.parse(vegaSpecConcat);
        const view = new vega.View(runtime)
            .renderer("svg")
            .initialize(containerRef.current)
            .hover(); // Enable hover interaction

        // Add Vega Tooltip handler
        new Handler().call(view);

        view.addEventListener("click", (event, item) => {
            console.log("Point clicked");
            console.log(item); // Access the clicked data point
        });

        // Cleanup on unmount
        return () => {
            view.finalize();
        };
    }, [graphParams]);

    return (
        <div>
            <div ref={containerRef} />
            {!data ? <div>Loading...</div> : null}
        </div>
    );
};

export default GraphVegaLiteAPI;
